import {Space} from 'antd';

import styled from 'styled-components';

export const StyledEmptyListContainer = styled(Space)`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
`;
